import { Box, Link, Typography } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import Teacher from '../../model/Teacher';
import CopyIconButton from './CopyIconButton';

type Props = {
	teachers: Teacher[];
	minWidth?: number;
};

const TeacherContacts = ({ teachers, minWidth = 220 }: Props) => {
	if (!teachers.length) {
		return (
			<Typography
				variant='caption'
				fontWeight='medium'
			>
				—
			</Typography>
		);
	}

	return (
		<Box
			sx={{
				border: '1px solid',
				borderColor: 'grey.300',
				borderRadius: 1,
				overflow: 'hidden',
				backgroundColor: 'common.white',
				minWidth,
			}}
		>
			{teachers.map((t) => {
				const phoneDigits = t.phone ? t.phone.replace(/\D+/g, '') : '';
				const phone =
					phoneDigits.length === 9
						? `${phoneDigits.slice(0, 3)}-${phoneDigits.slice(3, 6)}-${phoneDigits.slice(6)}`
						: t.phone;
				return (
					<Box
						key={t.id}
						sx={{
							display: 'flex',
							flexDirection: 'column',
							gap: 0.5,
							'&:not(:last-of-type)': {
								borderBottom: '1px solid',
								borderColor: 'grey.200',
							},
						}}
					>
						<Box
							sx={{
								backgroundColor: 'grey.800',
								color: 'common.white',
								px: 1,
								py: 0.5,
							}}
						>
							<Typography
								variant='caption'
								fontWeight='medium'
							>
								{`${t.firstName} ${t.lastName}`}
							</Typography>
						</Box>
						<Box sx={{ backgroundColor: 'common.white', px: 1, py: 0.75 }}>
							{t.email && (
								<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
									<EmailIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
									<Link
										href={`mailto:${t.email}`}
										underline='hover'
										variant='caption'
									>
										{t.email}
									</Link>
									<CopyIconButton
										value={t.email}
										ariaLabel='Skopiuj email nauczyciela'
									/>
								</Box>
							)}
							{t.phone && (
								<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
									<PhoneIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
									<Link
										href={`tel:${phoneDigits || t.phone}`}
										underline='hover'
										variant='caption'
									>
										{phone}
									</Link>
									<CopyIconButton
										value={phoneDigits || t.phone}
										ariaLabel='Skopiuj telefon nauczyciela'
									/>
								</Box>
							)}
						</Box>
					</Box>
				);
			})}
		</Box>
	);
};

export default TeacherContacts;
